<template>
  <el-dialog
          title="门店信息"
          :visible.sync="dialogVisible"
          @opened="dialogOpen"
  >
    <el-form
            ref="form"
            :model="form"
            label-width="100px"
            size="small"
    >
      <el-form-item
                    prop="shop_name"
                    label="店名"
                    :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.shop_name"></el-input>
      </el-form-item>
      <el-form-item
              prop="shop_no"
              label="编号"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.shop_no"></el-input>
      </el-form-item>
      <el-form-item
              prop="state"
              label="状态"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.state"
                placeholder="状态"
                width="50"
        >
          <el-option
                  v-for="item in stateOptions"
                  :key="item.velue"
                  :label="item.label"
                  :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="prov_cd"
              label="省"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.prov_cd"
                placeholder="请选择省"
                @change="currentSel(form.prov_cd)"
        >
          <el-option
                  v-for="item in typeOptions"
                  :key="item.areaid"
                  :label="item.areaname"
                  :value="item.areaid"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="city"
              label="市"
      >
        <el-select
                class="filter-item"
                v-model="form.city"
                placeholder="请选择市"
                @change="currentSel2(form.city)"
        >
          <el-option
                  v-for="item in typeOptions2"
                  :key="item.areaid"
                  :label="item.areaname"
                  :value="item.areaid"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="areaid"
              label="区"
      >
        <el-select
                class="filter-item"
                v-model="form.areaid"
                placeholder="请选择区"
        >
          <el-option
                  v-for="item in typeOptions3"
                  :key="item.areaid"
                  :label="item.areaname"
                  :value="item.areaid"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="compaddress"
              label="门店地址"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-button type="primary" plain  size="mini"    @click="opendw()">定位</el-button><el-input v-model="form.compaddress"></el-input>
      </el-form-item>
      <el-form-item
              prop="longitude"
              label="经度"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.longitude" readonly="readonly"></el-input>
      </el-form-item>
      <el-form-item
              prop="latitude"
              label="纬度"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.latitude" readonly="readonly"></el-input>
      </el-form-item>
      <el-form-item
              prop="address_remarks"
              label="地址备注"
      >
        <el-input v-model="form.address_remarks"></el-input>
      </el-form-item>

      <el-form-item
              prop="payment_description"
              label="支付凭证描述"
      >
        <el-input v-model="form.payment_description"></el-input>
      </el-form-item>
      <el-form-item
              prop="shop_logo"
              label="门店LOGO"
      >
        <el-input v-model="form.shop_logo" style="display:none"></el-input>
        <el-upload
                ref="upload"
                :action="imgUrl"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                list-type="picture-card"
                :limit=1
                :auto-upload="true"
                :file-list="fileList"
                :before-upload="handleBeforeUpload"
                :on-remove="handleRemove"
                :on-success="handlePictureCardPreview">
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>

      <el-form-item  v-if="formEdit">
        <el-button
                type="primary"
                :loading="loading"
                @click="saveUser"
        >保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>
    <editdw-form
            v-model="editFormVisible2"
            :compaddress2="compaddress2"
            :longitude2="longitude2"
            :latitude2="latitude2"
            @fatherMethod="fatherMethod"
    />
  </el-dialog>

</template>
<script>

    import * as userService from "@/api/sys/user";    import * as agentService from "@/api/sys/agent";
    import editdwForm from '@/pages/sys/shops/editdwForm';
    import util from '@/libs/util.js'
    export default {
        name: "shopsEditForm",
      components: { editdwForm},
        props: {
            agent: Object,
            accuseVisible:Boolean,
            value: Boolean
        },
        data() {
            return {
                imgUrl: process.env.VUE_APP_API+"/moblieapp/currencyUpload",
                fileList: [],
                formEdit: true,
                accuseVisible2:true,
                loading: false,
                dialogVisible: false,
              editFormVisible2: false,
                pickerOptions: {}, // 日期设置对象
              compaddress2:"",
              longitude2:"",
              latitude2:"",
                form: {
                    businessid: "",
                    businessname: "",
                    sort_id: ""
                },
                stateOptions: [
                    {
                        value: "0",
                        label: "正常"
                    },
                    {
                        value: "1",
                        label: "禁用"
                    }
                ],
                typeOptions: [],
                typeOptions2: [],
                typeOptions3: []

            };
        },
        watch: {
            value(val) {
                this.dialogVisible = val;
            },
            accuseVisible (newValue, oldValue) {
                console.log("-----"+newValue);
                this.accuseVisible2 = newValue;
            },

            dialogVisible(val) {
                this.$emit("input", val);
            }
        },
        methods: {
            dialogOpen() {
                this.$refs.form.resetFields();
                var formData2 = new FormData() // 声明一个FormData对象


                console.log("+++++++++++"+this.accuseVisible2);
                agentService.getProvcd(formData2).then(data => {
                    this.typeOptions=data;
                });

                if(this.agent.city){
                    this.currentSel(this.agent.prov_cd);
                }
                if(this.agent.areaid){
                    this.currentSel2(this.agent.city);
                }


                if (this.agent.id) {
                    // userService.getUser(this.user.id).then(data => {
                    let form = {};
                    form.shop_name = this.agent.shop_name;
                    form.shop_no = this.agent.shop_no;
                    form.state = this.agent.state;
                    form.prov_cd = this.agent.prov_cd;
                    form.city = this.agent.city;
                    form.areaid = this.agent.areaid;
                    form.compaddress = this.agent.compaddress;
                    form.address_remarks = this.agent.address_remarks;
                    form.payment_description = this.agent.payment_description;
                  if(this.agent.latitude!=null && this.agent.latitude!="") {
                    form.latitude = this.agent.latitude;
                  }else{
                    form.latitude ="";
                  }

                  if(this.agent.longitude!=null && this.agent.longitude!="") {
                    form.longitude = this.agent.longitude;
                  }else{
                    form.longitude ="";
                  }
                    if(this.agent.shop_logo!=null && this.agent.shop_logo!="") {
                        form.shop_logo=this.agent.shop_logo;
                        this.fileList = [{url: 'https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/' + this.agent.shop_logo}]
                    }
                    this.form = form;
                    // });
                    this.formEdit = this.accuseVisible2;
                } else {
                    this.formEdit = this.accuseVisible2;
                    this.form = {};
                }
            },
            // 上传文件之前的钩子
            handleBeforeUpload(file){
                let isJPG =true;
                // this.$message('上传模板只能是.jpg .jpeg .gif .png .bmp格式!');
                console.log('before');
                if(!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
                    isJPG=false;
                    this.$notify.warning({
                        title: '警告',
                        message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
                    })

                }
                let size = file.size / 1024 / 1024 / 2
                if(size > 2) {
                    this.$notify.warning({
                        title: '警告',
                        message: '图片大小必须小于2M'
                    })
                    isJPG=false;
                }

                return isJPG // 返回false不会自动上传
            },
            // 文件超出个数限制时的钩子
            handleExceed(files, fileList) {

            },
            // 文件列表移除文件时的钩子
            handleRemove(file, fileList) {
                this.form.shop_logo ="";
                this.dialogVisible = true;
            },
            // 点击文件列表中已上传的文件时的钩子
            handlePictureCardPreview(file) {
                console.log("url==="+file.url);
                this.form.shop_logo = file.url;
                this.dialogVisible = true;
            },
            currentSel(val) {
                if (this.agent.userId) {
                    this.form.city = "";
                    this.form.areaid = "";
                }
                this.typeOptions2=[];
                var formData2 = new FormData() // 声明一个FormData对象

                formData2.append('type','city')
                formData2.append('areaid',val)
                agentService.getProvcd(formData2).then(data => {
                    this.typeOptions2=data;
                });
            },
            currentSel2(val) {
                this.typeOptions3=[];
                var formData2 = new FormData() // 声明一个FormData对象
                formData2.append('type','area')
                formData2.append('areaid',val)
                agentService.getProvcd(formData2).then(data => {
                    this.typeOptions3=data;
                });
            },
          opendw() {
            this.compaddress2= this.form.compaddress;
            if(this.form.latitude!=null && this.form.latitude!="")
              this.latitude2=String(this.form.latitude);
            if(this.form.longitude!=null && this.form.longitude!="")
              this.longitude2=String(this.form.longitude);
            this.editFormVisible2=true;
          },
          fatherMethod(keyword,longitude,latitude) {
            console.log('测试'+keyword);
            this.form.compaddress=keyword;
            this.form.longitude=longitude;
            this.form.latitude=latitude;

          },
            saveUser() {
                this.$refs["form"].validate(valid => {
                    if (valid) {


                                        this.loading = true;
                                        agentService.saveAgentStore({ ...this.form,agentid:util.cookies.get('agentid'), id:this.agent.id })
                                            .then(data => {
                                                this.loading = false;
                                                this.dialogVisible = false;
                                                this.$emit("submit");
                                            });


                    } else {
                        return false;
                    }
                });
            },
            close() {
                this.$refs["form"].resetFields();
                this.dialogVisible = false;
            }
        }
    };
</script>

